function animateLineAndDot({
  lineElement,
  dotElement,
  start = 0,
  end = 100,
  duration = 1000,
  isStartY = false
}) {
  if (!lineElement || !dotElement) {
    console.error("Missing required elements.");
    return;
  }
  
  let startTime = null;

  // svg动画
  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const current = start + (end - start) * progress;

    if(!isStartY) {
      lineElement.setAttribute("x2", current);
      dotElement.setAttribute("cx", current);
    } else {
      lineElement.setAttribute("y2", current);
      dotElement.setAttribute("cy", current);
    }

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      const pointContext = lineElement.closest('div').querySelector('.point_context');
      console.log('lineElement', pointContext)
      if (pointContext) {
        pointContext.style.opacity = '1';
      }
    }
  }

  requestAnimationFrame(animate);
}

// 页面滚动
document.addEventListener("scroll", () => {
  const partTwoElement = document.querySelector(".part-two");
  if (!partTwoElement) {
    console.error("Element with class 'part-two' not found.");
    return;
  }

  const rect = partTwoElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const elementCenter = rect.top + rect.height / 2;

  if (elementCenter >= viewportHeight / 2 - 50 && elementCenter <= viewportHeight / 2 + 50) {
    const line1 = window.innerWidth < 1024 ? document.getElementById("animatedLine1_mobile") : document.getElementById("animatedLine1");
    const dot1 = window.innerWidth < 1024 ?  document.getElementById("movingDot1_mobile") : document.getElementById("movingDot1");
    const line2 = window.innerWidth < 1024 ? document.getElementById("animatedLine2_mobile") : document.getElementById("animatedLine2");
    const dot2 = window.innerWidth < 1024 ?  document.getElementById("movingDot2_mobile") : document.getElementById("movingDot2");

    if (!line1.dataset.animated) {
      animateLineAndDot({
        lineElement: line1,
        dotElement: dot1,
        start: 30,
        end: window.innerWidth < 1024 ? 150 : 300,
        duration: 600,
        isStartY: window.innerWidth < 1024 ? true : false
      });
      line1.dataset.animated = "true";
    }
    if (!line2.dataset.animated) {
      animateLineAndDot({
        lineElement: line2,
        dotElement: dot2,
        start: 30,
        end: window.innerWidth < 1024 ? 250 : 650,
        duration: 600,
        isStartY: window.innerWidth < 1024 ? true : false
      });
      line2.dataset.animated = "true";
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  var partSixSwiper = new Swiper('.part-six_swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
	  centeredSlides: true,
	  loop: true,
    loopAdditionalSlides: 1,
    navigation: {
      nextEl: '.part-six_swiper .swiper-button-next',
      prevEl: '.part-six_swiper .swiper-button-prev',
    },
  });
});